import { render, staticRenderFns } from "./addField.vue?vue&type=template&id=dbf66a00&scoped=true&v-cloak=true"
import script from "./addField.vue?vue&type=script&lang=js"
export * from "./addField.vue?vue&type=script&lang=js"
import style0 from "./addField.vue?vue&type=style&index=0&id=dbf66a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf66a00",
  null
  
)

export default component.exports